import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useSWR from 'swr';
import { URLS } from '../../services/urls';
import moment from 'moment';
import { useState } from 'react';
import { API } from '../../services/axios';
import NewProductForm from './components/NewProduct';
import { toast } from 'react-toastify';
import _, { result } from 'lodash';
import AllowOnly from '../../components/AllowOnly';
import { ROLE_RESPONSABLE_EXPLOITATION } from '../../components/utils/consts';

const Categories = ({ type }) => {
  const [toEdit, setToEdit] = useState();
  const [toEditProduct, setToEditProduct] = useState();
  const [isDeleting, setIsDeleting] = useState(false);

  const { active_agency } = useSelector((state) => state.agencies);
  const { auth } = useSelector((state) => state.auth);

  const {
    data: categories,
    isLoading,
    mutate,
  } = useSWR(URLS.PRODUCTS.CATEGORIES.groupedByLocation(active_agency?.id));

  const handleSuccess = () => {
    mutate();
    setToEdit();
  };

  const handleChangePrice = (id, value) => {
    API.patch(URLS.PRODUCTS.update(id), { price: value }).then((resp) => {
      mutate();
    });
  };
  const handleClose = () => {
    window.$('.btn-close')?.click();
  };

  const handleDelete = (obj) => {
    // NOTE: La suppression ici consiste uniquement a changer l'attribut in_stock = false afin de desactiver le produit.

    const toastId = toast.loading('Suppression en cours...');
    setIsDeleting(true);

    API.patch(URLS.PRODUCTS.update(obj.id), { is_active: !obj.is_active }).then((resp) => {
      mutate();
      toast.update(toastId, {
        render: !obj?.is_active ? 'Produit activé' : 'Produit désactivé',
        type: 'success',
        isLoading: false,
        autoClose: true,
      });
      setIsDeleting(false);
    }).catch((error) => {
      toast.update(toastId, {
        render: "Une erreur s'est produite, veuiller réessayer",
        type: 'error',
        isLoading: false,
        autoClose: true,
      });
      setIsDeleting(false);
    });
  }

  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex flex-row justify-content-between w-100">
          <div className="my-auto">
            <p className="text-uppercas h4 mb-0">Liste des Produits</p>
          </div>
          <div className="">
            <div>
              <AllowOnly allowedRoles={ROLE_RESPONSABLE_EXPLOITATION} userRole={auth?.user?.user_level}>
                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light px-3 rounded-"
                  data-bs-toggle="modal"
                  data-bs-target=".new-product-modal"
                >
                  {' '}
                  + Ajouter un {type === 'SERVICES' ? 'service' : 'produit'}
                </button>
              </AllowOnly>
              <div
                className="modal fade new-product-modal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="myLargeModalLabel">
                        {toEditProduct
                          ? 'Modifitation du produit ' + (toEditProduct.title ?? '')
                          : 'Nouveau ' + (type === 'SERVICES' ? 'service' : 'produit')}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <NewProductForm
                        type={type === 'SERVICES' ? 'SERVICE' : 'PRODUCT'}
                        handleClose={handleClose}
                        onSuccess={handleSuccess}
                        toEdit={toEditProduct}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12">
        <div>
          <div className="mt-3">
            <div className="">
              {
                categories?.map((location) => (
                  <div key={location.id} className='mb-4'>
                    <h4>Emplacement: {location?.name}</h4>
                    <div className="table-responsive">
                      <table className="table table-bordered text-uppercas">
                        <thead>
                          <tr className="bg-light">
                            <th>Référence</th>
                            <th>Nom du produit</th>
                            {/* <th>Famille</th> */}
                            {/* <th>CMUP</th> */}
                            {/* <th>Prix de vente</th> */}
                            <th>Date de Création</th>
                            <th>Actions</th>
                            {/* {!me && <th>Actions</th>} */}
                          </tr>
                        </thead>
                        <tbody>
                          {_.filter(location?.products, { is_active: true }).map((cat) => (
                              <tr key={'cat-' + cat.id} style={!cat.is_active ? {opacity: 0.5} : {}}>
                                <td>{cat.reference}</td>
                                <td>{String(cat.title).toUpperCase()}</td>
                                <td>
                                  {moment(cat.created_at).format('DD/MM/YYYY')}{' '}
                                  <span className="ms-3">{moment(cat.created_at).format('LT')}</span>
                                </td>
                                <td>
                                  <Link
                                    to="#" 
                                    onClick={() => handleDelete(cat)}
                                    disabled={isDeleting}
                                    className="btn btn-danger btn-sm ms-2"
                                    title={
                                      cat.is_active ?
                                      "Supprimer le produit"
                                      :
                                      "Reactiver le produit"
                                    }
                                  >
                                    { cat.is_active ?
                                      <i className="mdi mdi-trash-can-outline"></i>
                                      :
                                      <i className="mdi mdi-eye-outline"></i>
                                    }
                                    </Link>
                                  <Link
                                    to="#"
                                    onClick={() => setToEditProduct(cat)}
                                    className="btn btn-success btn-sm ms-2"
                                    data-bs-toggle="modal"
                                    data-bs-target=".new-product-modal"
                                  >
                                    <i className="mdi mdi-pencil"></i>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          }
                          {/* Inactives products */}
                          {categories?.results?.map((cate) => {
                            return _.filter(cate?.products, { is_active: false }).map((cat) => (
                              <tr key={'cat-' + cat.id} style={!cat.is_active ? {opacity: 0.5} : {}}>
                                <td>{cat.reference}</td>
                                <td>{String(cat.title).toUpperCase()}</td>
                                <td>
                                  {moment(cat.created_at).format('DD/MM/YYYY')}{' '}
                                  <span className="ms-3">{moment(cat.created_at).format('LT')}</span>
                                </td>
                                <td>
                                  <Link
                                    to="#" 
                                    onClick={() => handleDelete(cat)}
                                    disabled={isDeleting}
                                    className="btn btn-danger btn-sm ms-2"
                                    title={
                                      cat.is_active ?
                                      "Supprimer le produit"
                                      :
                                      "Reactiver le produit"
                                    }
                                  >
                                    { cat.is_active ?
                                      <i className="mdi mdi-trash-can-outline"></i>
                                      :
                                      <i className="mdi mdi-eye-outline"></i>
                                    }
                                    </Link>
                                  <Link
                                    to="#"
                                    onClick={() => setToEditProduct(cat)}
                                    className="btn btn-success btn-sm ms-2"
                                    data-bs-toggle="modal"
                                    data-bs-target=".new-product-modal"
                                  >
                                    <i className="mdi mdi-pencil"></i>
                                  </Link>
                                </td>
                              </tr>
                            ));
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Categories;
